import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { availableModes } from '../../../constants';

import { messages } from '../../../messages';
import style from './mode-selector.module.less';

export const ModeSelector = ({ mode, updateScanToPrintMode }) => {
  const intl = useIntl();
  const currentMode = messages[mode] ? intl.formatMessage(messages[mode]) : intl.formatMessage(messages.verifyAndPrint);
  return (
    <FlexColumn className={style['mode-selector']}>
      <Text textType={TextType.Label} value={messages.workflowModeLabel} />
      <DropdownMenu className={style['mode-display']} dropdownMenuShouldHaveWidthOfButton id='scan-mode-selector' variant='form'>
        <DropdownMenuToggler className={style.picker}>{currentMode}</DropdownMenuToggler>
        {Object.keys(availableModes).map((availableMode) => (
          <DropdownMenuItem key={availableMode} onClick={() => updateScanToPrintMode(availableMode)}>
            {intl.formatMessage(messages[availableMode])}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </FlexColumn>
  );
};

ModeSelector.propTypes = {
  mode: PropTypes.string.isRequired,
  updateScanToPrintMode: PropTypes.func.isRequired,
};
